import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles((theme) => ({
  versaCanvas: {
    marginTop: "32px",
    width: "100%",
    height: "100%",
  },
  integrationContent: {
    marginBottom: "90px"
  },
  details: {
    marginTop: "32px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  title: {
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "28px",
    marginBottom: "4px",
    color: colors.lightBlack,
  },
  description: {
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
    marginBottom: 0
  },
  buttonContainer: {
    width: "44px",
    height: "24px",
    display: "grid",
    justifyItems: "center"
  },
  skeletonButtonContainer: {
    width: "44px",
    height: "30px",
    display: "grid",
    justifyItems: "center"
  },
  toggleStyle: {
    marginLeft: "0px",
    width: "44px",
    height: "24px",
    display: "flex",
    justifyContent: "center"
  },
  logoDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "12px"
  },
  skeletonLogoDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "12px"
  },
  integrationCard: {
    width: "32%",
    display: "flex",
    borderRadius: "20px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    boxShadow: `0px 1px 3px 0px ${colors.shadowGrey}`,
    border: `1px solid ${colors.lightGrey}`,
    padding: "24px",
    gap: "8px",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginLeft: 0,
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%",
    },
  },
  skeletonIntegrationCard: {
    width: "40%",
    display: "flex",
    borderRadius: "20px",
    justifyContent: "space-between",
    boxShadow: `0px 1px 3px 0px ${colors.shadowGrey}`,
    border: `1px solid ${colors.lightGrey}`,
    padding: "24px",
    gap: "8px",
    alignItems: "center",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginLeft: 0,
    },
    [`@media (max-width: ${breakpoints.lg}px) and (min-width: ${breakpoints.md}px)`]: {
      width: "55%",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%",
    },
  },
  integrationsContent: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
    height: "fit-content",
    gap: "24px",
    margin: "24px 0px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      display: "grid",
    },
  },
  moreTxt: {
    color: colors.inactiveGrey,
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
    marginBottom: 0,
    marginTop: 0,
    marginLeft: "12px",
  },
  skeletonMoreTxt: {
    color: colors.inactiveGrey,
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
    marginBottom: 0,
    marginTop: 0,
  },
  logoTxt: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
    marginBottom: 0,
    marginTop: 0
  },
  addEmailDomainModal: {
    width: "400px",
    "& .modal-header": {
      padding: "24px 24px 20px 24px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px",
      fontSize: "18px",
      fontWeight:"600",
      lineHeight:"28px",
    },
    "& .body, .modal-body": {
      fontSize: "14px",
      fontWeight:"400",
      lineHeight:"20px",
    },
    "& .modal-body": {
      padding: "8px 24px 24px",
      wordBreak: "break-word"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  cancelButton: {
    width: "100%",
    backgroundColor: colors.darkBlue,
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    marginTop: "32px",
    height: "44px",
    "& a":{
      color:colors.white,
      textDecoration:"none"
    }
  },
  iconColor: {
    "& path": {
      stroke: theme.icon.stroke
    }
  },
  linkStyle: {
    textDecoration: "none",
    color: theme.buttons.defaultLink.color
  },
  logoSvg: {
    padding: "2px"
  },
  spinnerClassName: {
    position: "relative",
    marginLeft: "0px",
    left: "unset",
    "& span": {
      marginLeft: "unset"
    },
  }
}));

export default styles;